import { graphql } from '@/client/services/api/graphql/gql';

export const adminMessagingDetailQuery = graphql(`
  query AdminAppAnnouncement($id: String!) {
    appAnnouncement(id: $id) {
      id
      title
      content
      routes
      published
      publishedAt
      createdAt
      createdBy {
        id
        fullName
      }
      segmentation {
        type
        id
        name
      }
      translations {
        languageCode
        content
      }
    }
  }
`);
